import InputComponent from "../../components/elements/InputComponent";
import { IFormData } from "../../pages/seller-stepper/SellerStepper";
import InputPlusButton from "../elements/InputPlusButton";
import UploderComponent from "../elements/UploderComponent";
import ButtonComponent from "../elements/ButtonComponent";
import TextareaComponent from "../elements/TextareaComponent";
import ControlledSelectElement from "../elements/ControlledSelectElement2";
import ControlledSelectElementNew from "../elements/ControlledSelectElement";
import UserIcon, { PhonenumberIcon, PostalIcon } from "../Icons";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { useState, useEffect } from "react";
import { requiredMessage } from "../../utils/validationCustomMessages";
import { axiosPrivate } from "../../api/axios";
import { motion } from "framer-motion";
import { z } from "zod";
import customZ from "../../utils/setZodCustomMessages";
import {
  notEmptyField,
  landlinenumberSchemaJob,
  onlyNumberSchema,
  secondMobileNumberSchema,
  postalCodeSchema,
  idCardFieldSchema,
} from "../../utils/customSchemas";
import { zodResolver } from "@hookform/resolvers/zod";
import { childVariants } from "../../animation/RoutesAnimations";
import { CustomAxiosRequestConfig } from "../login/EnterOtp";
import UploderLogoComponent from "../elements/UploderLogoComponent";
import Lottie from "react-lottie";
import animationData from "../../../src/jsons/LoadingBg.json";
import { useMutation } from "@tanstack/react-query";
import _ from "lodash";
import {
  CORE_CITY,
  CORE_CITY_NO_ID,
  CORE_PROVINCE,
  GET_FILE,
  STORE_STORE_GET_INFO_UID,
  COMMON_STORE_GROUPS,
  STORE_STORE_INFO_CREATE,
  STORE_STORE_INFO_UPDATE,
} from "../../api/apiClient";
import MapComponent from "../common/MapComponent";

const step2Schema = customZ
  .object({
    name: notEmptyField,
    telephone_number: landlinenumberSchemaJob,
    phone_number_sec: secondMobileNumberSchema,
    postal_code: postalCodeSchema,
    address: notEmptyField,
    lat: onlyNumberSchema,
    lng: onlyNumberSchema,
    store_image: idCardFieldSchema,
    store_doc_img: idCardFieldSchema,
    logo: idCardFieldSchema,
    cityDetails: z.custom(),
    city: z.string().refine((value) => value !== "undefined", {
      message: requiredMessage,
    }),
    store_group_uid: z.custom(),
    operation_code: z.string().optional().nullable(),
  })
  .superRefine((data, ctx) => {
    if (
      data.store_group_uid !== null &&
      data.store_group_uid !== undefined &&
      data.store_group_uid !== ""
    ) {
      if (!data.operation_code) {
        ctx.addIssue({
          path: ["operation_code"],
          message:
            "در صورت انتخاب 'گروه خاص' میبایست کد عاملیت خود را ثبت نمایید.",
          code: z.ZodIssueCode.custom,
        });
      }
    }
  });

function SellerFormStep2({ formNo, setFormNo, onBack, setState }: any) {
  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm<IFormData>({
    resolver: (data, context, options) => {
      return zodResolver(step2Schema)(data, context, options);
    },
  });
  const [isLoadingContents, setIsLoadingContents] = useState<boolean>(false);

  const access_token = localStorage.getItem("access_token");
  const store_uid = localStorage.getItem("selected_store_uid");
  const [sellerForm2Info, setSellerForm2Info] = useState<any>(undefined);
  const [getData, setGetData] = useState<any>(undefined);
  const [formIsChanged, setFormIsChanged] = useState(false);
  const [imageDoc, setImageDoc] = useState(null);
  const [imageStore, setImageStore] = useState(null);
  const [imageLogo, setImageLogo] = useState(null);
  const [isImageDocLoading, setIsImageDocLoading] = useState(true);
  const [isImageStoreLoading, setIsImageStoreLoading] = useState(true);
  const [isSubmiting, setIsSubmiting] = useState(true);
  const [city, setCity] = useState([
    { name: "", id: 1, city: 1, prefix_number: "021" },
  ]);
  const [province, setProvince] = useState([{ name: "", id: 1 }]);
  const [prefixNum, setPrefixNum] = useState<any>(undefined);
  const [prName, setPRName] = useState<any>(undefined);
  const [ciName, setCIName] = useState<any>(undefined);
  const [lng, setLng] = useState<any>(undefined);
  const [lat, setLat] = useState<any>(undefined);
  const [receivedValue, setReceivedValue] = useState("");
  const [cityId, setCityId] = useState<number>(1);
  const handleValueReceived = (value: any) => {
    setReceivedValue(value);
  };
  const [sendImageToApi, setSendImageToApi] = useState(false);

  useEffect(() => {
    if (receivedValue) {
      setValue("address", receivedValue);
    }
  }, [receivedValue]);

  useEffect(() => {
    if (
      city[
      city.findIndex((obj: any) => obj["id"] === Number(getValues("city")))
      ] !== undefined
    ) {
      setPrefixNum(
        city[
        city.findIndex((obj: any) => obj["id"] === Number(getValues("city")))
        ]["prefix_number"]
      );
    } else {
      setPrefixNum(null);
    }
  }, [getValues("city")]);

  const getProvince = async () =>
    axiosPrivate
      .get(
        CORE_PROVINCE,

        {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      )
      .then((res) => res.data.data.result);

  const provinceMutation = useMutation({
    mutationFn: () => getProvince(),
    onSuccess(data, variables, context) {
      setProvince(data);
    },
  });

  const getAllCity = async () =>
    axiosPrivate
      .get(CORE_CITY_NO_ID, {
        headers: {
          // prettier-ignore
          "accept": "application/json",
          // prettier-ignore
          "Authorization": `Bearer ${access_token}`,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      })
      .then((res) => res.data.data.result);

  const findProvinceMutation = useMutation({
    mutationFn: () => getAllCity(),
    onSuccess(data: any, variables, context) {
      let res = data;
      setValue(
        "id",
        String(
          res[res.findIndex((obj: any) => obj["id"] === cityId)]["province_id"]
        )
      );
      var city_name =
        res[res.findIndex((obj: any) => obj["id"] === cityId)]["name"];

      setPrefixNum(
        res[res.findIndex((obj: any) => obj["id"] === cityId)]["prefix_number"]
      );

      var province_name =
        province[
        province.findIndex(
          (o: any) =>
            o["id"] ===
            res[res.findIndex((obj: any) => obj["id"] === cityId)][
            "province_id"
            ]
        )
        ]["name"];
      setPRName(province_name);
      setCIName(city_name);
    },
  });

  useEffect(() => {
    if (sellerForm2Info) {
      setCityId(sellerForm2Info.city);
      findProvinceMutation.mutate();
    }
  }, [sellerForm2Info, provinceMutation.isSuccess]);

  const [sendDocImageToApi, setsendDocImageToApi] = useState<boolean>(false);

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [label, setLabel] = useState(
    selectedFile !== null ? selectedFile?.name : " فایلی انتخاب نشده است."
  );

  const [showSpecialGroup, setShowSpecialGroup] = useState(false);

  const [select, setSelect] = useState<any>([]);

  useEffect(() => {
    const getSelectSpecialGroup = async () => {
      try {
        const response = await axiosPrivate.get(COMMON_STORE_GROUPS, {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            // prettier-ignore
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        });
        if (response?.status >= 200 && response?.status < 300) {
          const resultWithNoneOption = [...response?.data?.data?.result];
          setSelect(resultWithNoneOption);
        }
      } catch (error) { }
    };
    getSelectSpecialGroup();
  }, []);

  const onSubmitStep2: SubmitHandler<IFormData> = async (data: IFormData) => {
    setIsSubmiting(true);

    const formattedData = {
      ...data,
      lat,
      lng,
    };
    const filterFormData = (data: any) => {
      const filteredData = {
        ...data,
        store_image: sendImageToApi ? data?.store_image : null,
        store_doc_img: sendDocImageToApi ? data?.store_doc_img : null,
        lat,
        lng,
        logo: null,
      };
      if (!showSpecialGroup) {
        delete filteredData.store_group_uid;
        delete filteredData.operation_code;
      }
      return filteredData;
    };
    const filteredData = filterFormData(data);

    if (!sellerForm2Info) {
      try {
        const response = await axiosPrivate.post(
          STORE_STORE_INFO_CREATE,
          formattedData,
          {
            headers: {
              // prettier-ignore
              "accept": "application/json",
              // prettier-ignore
              "Authorization": `Bearer ${access_token}`,
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          }
        );

        if (response?.status >= 200 && response?.status < 300) {
          localStorage.setItem(
            "selected_store_uid",
            response?.data?.data?.store_uid
          );
          setIsSubmiting(false);

          setFormNo(formNo + 1);
          setState((prevState: any) => ({
            ...prevState,
            store_uid: response.data.data.store_uid,
          }));
        } else {
          console.error(
            "ERROR in store_info create:",
            response.data || response.statusText
          );
        }
      } catch (error) {
        setIsSubmiting(false);
        console.error("An unexpected error occurred:", error);
      }
    } else {
      if (formIsChanged) {
        try {
          const response = await axiosPrivate.put(
            STORE_STORE_INFO_UPDATE(store_uid),
            filteredData,
            {
              headers: {
                // prettier-ignore
                "accept": "application/json",
                // prettier-ignore
                "Authorization": `Bearer ${access_token}`,
                "Content-Type": "multipart/form-data",
              },
              withCredentials: true,
            }
          );
          if (response?.status >= 200 && response?.status < 300) {
            setIsSubmiting(false);
            setFormNo(formNo + 1);
          } else {
            console.error(
              "ERROR in store_info create:",
              response.data || response.statusText
            );
          }
        } catch (error) {
          setIsSubmiting(false);
          console.error("An unexpected error occurred:", error);
        }
      } else {
        setFormNo(formNo + 1);
      }
    }
    secondFunction();
  };

  const secondFunction = () => { };

  useEffect(() => {
    if (
      getValues("store_group_uid") !== null &&
      getValues("store_group_uid") !== undefined &&
      getValues("store_group_uid") !== ""
    ) {
      setShowSpecialGroup(true);
    }
    if (getValues("store_group_uid") === "undefined") {
      setShowSpecialGroup(false);
    }
  }, [getValues("store_group_uid")]);

  const getSellerForm2Info = async () => {
    setIsLoadingContents(true);
    setIsSubmiting(true);
    try {
      const response = await axiosPrivate.get(
        STORE_STORE_GET_INFO_UID(store_uid),

        {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );
      setState((prevState: any) => ({
        ...prevState,
        store_uid: response.data.data.store_uid,
      }));

      setSellerForm2Info(response?.data.data);
      setLat(response?.data?.data?.lat);
      setLng(response?.data?.data?.lng);

      if (response?.status >= 200 && response?.status < 300) {
        setIsImageDocLoading(true);
        setIsImageStoreLoading(true);

        setIsLoadingContents(false);
        setIsSubmiting(false);
      } else {
        setIsLoadingContents(false);
      }
    } catch (error) {
      setIsImageDocLoading(false);
      setIsImageStoreLoading(false);

      setIsLoadingContents(false);
      setIsSubmiting(false);
    } finally {
      setIsLoadingContents(false);
    }
  };

  useEffect(() => {
    getSellerForm2Info();
    provinceMutation.mutate();
  }, []);

  useEffect(() => {
    setValue("name", sellerForm2Info?.name);
    setValue("telephone_number", sellerForm2Info?.telephone_number);
    setValue(
      "phone_number_sec",
      sellerForm2Info?.phone_number_sec ? sellerForm2Info?.phone_number_sec : ""
    );
    setValue("postal_code", sellerForm2Info?.postal_code);
    setValue(
      "address",
      receivedValue ? receivedValue : sellerForm2Info?.address
    );

    setValue("store_doc_img", sellerForm2Info?.store_doc_img);
    setValue("store_image", sellerForm2Info?.store_image);
    setValue("city", String(sellerForm2Info?.city));
    setValue("logo", sellerForm2Info?.logo_uid);
    setValue(
      "operation_code",
      sellerForm2Info?.operation_code === "undefined"
        ? ""
        : sellerForm2Info?.operation_code
    );
    setValue(
      "store_group_uid",
      sellerForm2Info?.store_group?.store_group_uid === "undefined"
        ? ""
        : sellerForm2Info?.store_group?.store_group_uid
    );
  }, [setValue, sellerForm2Info]);

  useEffect(() => {
    const textAreaValue = getValues("address");

    if (receivedValue && textAreaValue === receivedValue) {
      setValue("address", receivedValue);
    }
  }, [receivedValue, getValues]);

  const fetchImageDoc = async () => {
    setIsImageDocLoading(true);

    try {
      const response = await axiosPrivate.get(
        GET_FILE(sellerForm2Info?.store_doc_img),
        {
          headers: {
            accept: "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },

          withCredentials: true,
        }
      );

      setImageDoc(response?.data?.data?.url);
      setIsImageDocLoading(false);
    } catch (error) {
      setIsImageDocLoading(false);

      console.error("Error fetching image data:", error);
    }
  };

  const fetchImageStore = async () => {
    setIsImageStoreLoading(true);

    try {
      const response = await axiosPrivate.get(
        GET_FILE(sellerForm2Info?.store_image),
        {
          headers: {
            accept: "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );
      if (response?.status >= 200 && response?.status < 400) {
        setImageStore(response?.data?.data?.url);
        setIsImageStoreLoading(false);
      }
    } catch (error) {
      setIsImageStoreLoading(false);

      console.error("Error fetching image data:", error);
    }
  };

  const fetchImageLogo = async () => {
    try {
      const response = await axiosPrivate.get(
        GET_FILE(sellerForm2Info?.logo_uid),
        {
          headers: {
            accept: "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },

          withCredentials: true,
        }
      );
      if (response?.data?.data?.url !== null) {
        setLabel("فایل ثبت شده است.");
      }
      setImageLogo(response?.data?.data?.url);
    } catch (error) {
      console.error("Error fetching image data:", error);
    }
  };

  useEffect(() => {
    sellerForm2Info && fetchImageDoc();
    sellerForm2Info && fetchImageStore();
    sellerForm2Info && fetchImageLogo();
  }, [
    sellerForm2Info?.store_image,
    sellerForm2Info?.store_doc_img,
    sellerForm2Info?.logo_uid,
  ]);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  function cityAdder(data: any) {
    for (let i = 0; i < data.length; i++) {
      data[i]["city"] = data[i]["id"];
    }
    return data;
  }
  const getCityTest = (id: number) =>
    axiosPrivate
      .get(
        CORE_CITY(id),

        {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,

          globalErrorHandler: false,
        } as CustomAxiosRequestConfig
      )
      .then((res) => cityAdder(res.data.data.result));

  const cityMutate = useMutation({
    mutationFn: (id: any) => getCityTest(id),
    onSuccess(data, variables, context) {
      setCity(data);
    },
  });

  useEffect(() => {
    if (
      getData === undefined &&
      prName !== undefined &&
      sellerForm2Info !== undefined &&
      imageLogo !== null &&
      imageStore !== null &&
      imageDoc !== null
    ) {
      setGetData(watch());
    } else if (getData !== undefined) {
      setFormIsChanged(!_.isEqual(getData, watch()));
      if (lat !== sellerForm2Info?.lat || lat !== sellerForm2Info?.lng) {
        setFormIsChanged(true);
      }
    }
  }, [watch(), sellerForm2Info, lat, lng]);

  useEffect(() => {
    getValues("id") !== undefined &&
      watch("id") !== "undefined" &&
      cityMutate.mutate(watch("id"));
  }, [watch("id"), getValues("id")]);

  useEffect(() => {
    if (
      (lng !== undefined || lng !== null) &&
      (lat !== undefined || lat !== null)
    ) {
      setValue("lat", String(lat));
      setValue("lng", String(lng));
    }
  }, [lng, lat]);

  return (
    <>
      {isLoadingContents ? (
        <>
          <div className="flex  gap-8 basis-3/4 rounded-md md:ml-8 ml-2 shadow-md">
            <div className=" full-screen">
              <Lottie options={defaultOptions} height={100} width={100} />
            </div>
          </div>
        </>
      ) : (
        <motion.form
          variants={childVariants}
          initial="initial"
          animate="final"
          onSubmit={handleSubmit(onSubmitStep2)}
          className="flex flex-1 gap-4 rounded-md shadow-md pb-20 flex-col"
        >
          <div className=" mt-3 mb-[0px]">
            <label className=" text-gray-900 text-Body-OneLine/14/Regular ">
              تصویر فروشگاه
            </label>
            <span className="text-red-500 mr-[4px]">*</span>
          </div>
          <Controller
            control={control}
            name="store_image"
            rules={{ required: true }}
            render={({ field }) => {
              return (
                <UploderComponent
                  isStoreImage={true}
                  errors={errors?.store_image}
                  onChange={(file: any) => {
                    field.onChange(file);
                  }}
                  defaultValue={imageStore ? imageStore : null}
                  onRemove={() => {
                    setImageStore(null);
                    field.onChange(null);
                    setSendImageToApi(true);
                    field.onChange(null);
                  }}
                  isLoading={isImageStoreLoading}
                  loadingHeight="h-[223px]"
                />
              );
            }}
          />
          <div className="lg:flex flex-1 lg:flex-auto gap-6 rounded-md shadow-md mt-6 w-full">
            <div className=" flex flex-col w-full">
              <InputComponent
                defaultValue={sellerForm2Info?.name}
                size="regular"
                isRequired
                label=" نام فروشگاه "
                name="name"
                control={control}
                errors={errors?.name}
                svgIcon={<UserIcon />}
              />
              <div className="flex ">
                <div className="ml-3 w-[50%]">
                  <ControlledSelectElement
                    APIgetValue={sellerForm2Info ? prName : undefined}
                    label=" استان"
                    isLoading={
                      sellerForm2Info
                        ? findProvinceMutation?.isPending
                        : provinceMutation?.isPending
                    }
                    options={province}
                    isRequired
                    getOptionLabel={(item) => item?.name}
                    control={control}
                    name="id"
                    errors={errors?.id}
                    showNonOption
                    defaultSelectValue={"انتخاب کنید"}
                    mode="multiSelect"
                  />
                </div>
                <div className="w-[50%]">
                  <ControlledSelectElement
                    APIgetValue={sellerForm2Info ? ciName : undefined}
                    disabled={watch("id") === undefined}
                    isLoading={cityMutate.isPending}
                    label="شهر"
                    options={city}
                    isRequired
                    getOptionLabel={(item) => item?.name}
                    control={control}
                    name="city"
                    errors={errors?.city}
                    showNonOption
                    defaultSelectValue={"انتخاب کنید"}
                    mode="multiSelect"
                  />
                </div>
              </div>
              <div className="relative">
                <InputComponent
                  defaultValue={sellerForm2Info?.telephone_number}
                  direction="ltr"
                  size="regular"
                  isRequired
                  type="tel"
                  label=" شماره ثابت فروشگاه "
                  name="telephone_number"
                  control={control}
                  errors={errors?.telephone_number}
                  svgIcon={<PhonenumberIcon />}
                  maxLength={8}
                  fixNumber="px-[80px]"
                />
                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-900 pl-3 pr-6 text-sm border-r-2 border-gray-300 p-1">
                  {prefixNum === null ? "021" : prefixNum}
                </span>
              </div>

              <InputComponent
                defaultValue={sellerForm2Info?.phone_number_sec}
                size="regular"
                type="tel"
                label=" شماره موبایل دوم "
                name="phone_number_sec"
                control={control}
                errors={errors?.phone_number_sec}
                maxLength={11}
                svgIcon={<PhonenumberIcon />}
              />

              <div className="">
                <div className="">
                  <label className=" text-gray-900 text-Body-OneLine/14/Regular">
                    کد پستی فروشگاه
                  </label>
                  <span className="text-red-500 mr-[4px]">*</span>
                </div>
                <div className="">
                  <InputPlusButton
                    onValueReceived={handleValueReceived}
                    editable={true}
                    APIgetValue={sellerForm2Info?.postal_code}
                    type="tel"
                    name="postal_code"
                    btnText="استعلام"
                    btnDisabled={true}
                    inputIcon={<PostalIcon />}
                    control={control}
                    errors={errors?.postal_code}
                    maxLength={10}
                    direction="ltr"
                  />
                </div>
              </div>
              <TextareaComponent
                helperText="در صورت صحیح نبودن آدرس استعلام شده، آدرس را ویرایش نمایید."
                APIgetValue={receivedValue ? receivedValue : ""}
                latestReceivedValue={receivedValue}
                editable={true}
                value={
                  receivedValue
                    ? receivedValue
                    : sellerForm2Info?.address
                      ? sellerForm2Info?.address
                      : undefined
                }
                dynamicRows={3}
                control={control}
                label="آدرس فروشگاه،"
                name="address"
                errors={errors?.address}
                isRequired
                onChange={(value) => handleValueReceived(value)}
              />

              <div className="w-full my-4">
                <ControlledSelectElementNew
                  getValue={getValues}
                  APIgetValue={sellerForm2Info?.store_group?.name}
                  label="گروه خاص"
                  options={select || []}
                  getOptionLabel={(item: any) => item?.name}
                  control={control}
                  name="store_group_uid"
                  errors={errors?.store_group_uid}
                  showNonOption
                  defaultSelectValue="بدون گروه"
                  mode="multiSelect"
                />
              </div>
              {showSpecialGroup && watch("store_group_uid") !== null && (
                <div className="w-full -mt-4 ">
                  <InputComponent
                    defaultValue={sellerForm2Info?.operation_code}
                    size="regular"
                    isRequired
                    label="کد عاملیت"
                    name="operation_code"
                    control={control}
                    errors={
                      getValues("store_group_uid") && errors?.operation_code
                    }
                    svgIcon={<UserIcon />}
                  />
                </div>
              )}
            </div>
            <div className="w-full lg:mr-10">
              <div className="mb-[8px]">
                <label className=" text-gray-900 text-Body-OneLine/14/Regular">
                  تصویر سند یا اجاره نامه
                </label>
                <span className="text-red-500 mr-[4px]">*</span>
              </div>
              <Controller
                control={control}
                name="store_doc_img"
                rules={{ required: true }}
                render={({ field }) => {
                  return (
                    <UploderComponent
                      errors={errors?.store_doc_img}
                      onChange={(file: any) => {
                        field.onChange(file);
                      }}
                      defaultValue={imageDoc ? imageDoc : null}
                      onRemove={() => {
                        setImageDoc(null);
                        field.onChange(null);
                        setsendDocImageToApi(true);
                      }}
                      loadingHeight="h-[223px]"
                      isLoading={isImageDocLoading}
                    />
                  );
                }}
              />

              <div className="mt-3 mb-1">
                <label className="text-gray-900 text-Body-OneLine/14/Regular mt-8">
                  آپلود لوگو فروشگاه
                </label>
                <span className="text-red-500 mr-[4px]">*</span>
              </div>
              <Controller
                control={control}
                name="logo"
                rules={{ required: true }}
                render={({ field }) => {
                  return (
                    <UploderLogoComponent
                      errors={errors?.logo}
                      onChange={(file: any) => {
                        field.onChange(file);
                      }}
                      labeltxt={label}
                    />
                  );
                }}
              />
              <div className="flex w-full mt-6 ">
                <MapComponent
                  lat={lat}
                  setLat={setLat}
                  lng={lng}
                  setLng={setLng}
                  errors={errors}
                />
              </div>
              <div className="h-28" />
            </div>
          </div>
          <div className="flex w-full justify-center gap-1 pb-4 sticky bottom-0 bg-white right-0 left-0 z-[4]">
            <ButtonComponent
              className="mt-8 w-[120px] h-10"
              variant="outlined"
              onClick={onBack}
            >
              بازگشت
            </ButtonComponent>
            <ButtonComponent
              type="submit"
              className="mt-8 w-[120px] h-10 mr-[8px]"
              variant="filled"
              isClicked={isSubmiting}
              disabled={isSubmiting}
            >
              ادامه
            </ButtonComponent>
          </div>
        </motion.form>
      )}
    </>
  );
}

export default SellerFormStep2;
